import { setUserIfEmpty, unsetUser } from 'redux/reducers/user-reducer';
import {
  setMarketplacesIfEmpty,
  unsetMarketplaces,
} from 'redux/reducers/marketplaces-reducer';
import { setGroupsIfEmpty, unsetGroups } from 'redux/reducers/groups-reducer';
import {
  setWarehousesIfEmpty,
  unsetWarehouses,
} from 'redux/reducers/warehouses-reducer';
import {
  setAgenciesIfEmpty,
  unsetAgencies,
} from 'redux/reducers/agencies-reducer';

export const feedStore = () => (dispatch, getState) => {
  setTimeout(() => {
    dispatch(setUserIfEmpty());
    dispatch(setMarketplacesIfEmpty());
    dispatch(setGroupsIfEmpty());
    dispatch(setWarehousesIfEmpty());
    dispatch(setAgenciesIfEmpty());
  }, 100);
};

export const emptyStore = () => async (dispatch, getState) => {
  dispatch(unsetUser());
  dispatch(unsetMarketplaces());
  dispatch(unsetGroups());
  dispatch(unsetWarehouses());
  dispatch(unsetAgencies());
};
